import { ISupplyData } from "@types"
import { protectedApi } from "store/Api"

const devicesSupplyData = protectedApi.injectEndpoints({

    endpoints: (builder) => ({
        deviceSupplyData: builder.query<ISupplyData[], void>({
            query: () => {
                return {
                    method: "GET",
                    url: `devices/supply_data`,
                }
            },
        }),
    }),
})

export const { useDeviceSupplyDataQuery } = devicesSupplyData
